import { command } from "@lookiero/messaging";
const SYNC_TRANSLATION = "sync_translation";
const syncTranslation = ({ aggregateId, ...payload }) => ({
    ...command({ aggregateId, name: SYNC_TRANSLATION }),
    ...payload,
});
export { SYNC_TRANSLATION, syncTranslation };
